import React from "react";

const EditorValidationModal = props => (
  <div className="modal__body">
    <div className="modal__close" onClick={props.handleCloseModal}>
      <svg className="bars-icon" viewBox="0 0 24 24">
        <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
      </svg>
    </div>
    <div className="modal__editor-welcome">
      {props.t("editor:validationMessage")}
    </div>
  </div>
);

export default EditorValidationModal;



// WEBPACK FOOTER //
// ./src/components/modals/EditorValidationModal.js